import { render, staticRenderFns } from "./UsersSlimList.vue?vue&type=template&id=2e8acb51"
import script from "./UsersSlimList.vue?vue&type=script&lang=js"
export * from "./UsersSlimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports